import React, { useState, useEffect } from "react";
import Finalnav from "./Finalnav";
import Cards from "./Cards";
import Homee from "./Homee";
import Header from "./Header";
import Service from "./Service";
import Carousel from "./Carousel";
import Connect from "./Connect";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";

// import Testimonials from "./Testimonials";
import Information from "./Information";
import HomeContent from "./HomeContent";
import ContactUs from "./ContactUs";
import Footer from "./Footer";
import DoaguruBannerDisplay from "../../components/Displayname";
import HeroHome from "../HomePageNew/HeroHome";
import ServiceHomeOne from "../HomePageNew/ServiceHomeOne";
import HeroHomeTwo from "../HomePageNew/HeroHomeTwo";
import HeroHomeFive from "../HomePageNew/HeroHomeFive";
import VideoHomeTwo from "../HomePageNew/VideoHomeTwo";
import VideoPopup from "../HomePageNew/VideoPopup";
import AboutHomeOne from "../HomePageNew/About";
import Portfolio from "../HomePageNew/Portfolio";
import OurClient from "../HomePageNew/OurClient";
import Testimonial from "../HomePageNew/Testimonial";
import Contact from "../HomePageNew/Contact";
import HeaderOne from "../HomePageNew/HeaderOne";
import FooterOne from "../HomePageNew/FooterOne";

// import backimg from "../../components/images/imgback.png";
// import backimg2 from "../../components/images/imgback2.png";

function Homepage() {
  const [isVideoOpen, setIsVideoOpen] = useState(false);
  return (
    <>
      <Wrapper>
        <Helmet>
          <meta charSet="utf-8" />
          <title>
            Best Digital Marketing & IT Solutions Company in India | DOAGuru InfoSystems
          </title>

          <meta
            name="description"
            content="DOAGuru InfoSystems,  best digital marketing company in jabalpur, offers SEO, PPC, social media, and content services to grow your business."
          />

          <meta
            name="Keywords"
            content="digital marketing company Jabalpur, SEO Jabalpur, PPC services Jabalpur, social media marketing Jabalpur, content marketing Jabalpur, DOAGuru InfoSystems"
          />

          {/* Robots Tag */}
          <meta name="robots" content="index, follow" />

          {/* Author */}
          <meta name="author" content="DOAGuru InfoSystems" />

          {/* Publisher */}
          <meta name="publisher" content="DOAGuru InfoSystems" />

          {/* OG Tags */}
          <meta property="og:title" content="Best Digital Marketing & IT Solutions Company in India | DOAGuru InfoSystems" />
          <meta property="og:site_name" content="DOAGuru InfoSystems" />
          <meta property="og:url" content="https://doaguru.com/" />
          <meta property="og:description" content="DOAGuru InfoSystems — India's trusted Digital Marketing & IT Solutions Company. SEO, Google Ads, Web Dev, Software & Mobile Apps. 100+ clients. Based in Jabalpur, MP. FREE consultation!" />
          <meta property="og:type" content="website" />
          <meta property="og:image" content="https://doaguru.com/uploads/doaguru-og-img.jpeg" />
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content="Best Digital Marketing & IT Solutions Company in India | DOAGuru InfoSystems" />

          {/* Schema */}
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "FAQPage",
              "@id": "https://doaguru.com/#faq",
              "mainEntity": [
                {
                  "@type": "Question",
                  "name": "What digital marketing and IT services does DOAGuru InfoSystems offer?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "DOAGuru InfoSystems offers a complete range of Digital Marketing and IT Solutions including SEO (Search Engine Optimization), Google Ads & PPC, Social Media Marketing (Facebook, Instagram, LinkedIn), Content Marketing, Website Design & Development, Mobile App Development, Software Development, Graphic Designing, and Data Analysis. We serve businesses of all sizes across India."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Does DOAGuru provide services outside Jabalpur? Do you work pan-India?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! DOAGuru InfoSystems serves businesses across all of India — Delhi, Mumbai, Bangalore, Hyderabad, Pune, Chennai, Bhopal, Indore, and beyond. All our Digital Marketing & IT services are delivered remotely with the same quality and dedication. Distance is no barrier for digital success."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What is the cost of digital marketing services at DOAGuru?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "DOAGuru's digital marketing packages start from ₹8,000/month for small businesses (basic SEO + social media). Comprehensive packages range from ₹15,000 to ₹50,000+/month depending on services, competition, and goals. IT solutions like website development start from ₹15,000. Contact us for a FREE custom quote."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How long does SEO take to show results?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "SEO is a long-term strategy. With DOAGuru's proven methods, most clients see initial keyword ranking improvements within 60-90 days. Significant organic traffic increase is typically visible within 4-6 months. Competitive national keywords may take 6-12 months. We provide monthly reports so you always know your progress."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Is DOAGuru an IT company or a Digital Marketing company?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "DOAGuru InfoSystems is both! We are a full-service Digital Marketing & IT Solutions company. On the digital marketing side, we offer SEO, PPC, Social Media, and Content services. On the IT side, we develop websites, mobile apps, and custom software. This makes us a single-window solution for all your business's digital needs."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How is DOAGuru different from other digital marketing agencies in India?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "DOAGuru InfoSystems stands out because: (1) We offer both Digital Marketing & IT under one roof, (2) We have 5+ years of proven experience with 100+ clients, (3) We provide dedicated account managers, (4) Monthly transparent reporting, (5) We are based in Jabalpur and understand tier-2 city business needs while serving national brands."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Do you offer website development along with digital marketing?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! DOAGuru is a complete Digital Marketing & IT Solutions company. We build SEO-optimised websites, eCommerce stores, mobile apps, and custom software — and then promote them through our digital marketing services. Clients who use both services see 2-3x better results because website and marketing work together seamlessly."
                  }
                },
                {
                  "@type": "Question",
                  "name": "How can I get started with DOAGuru?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Getting started is easy! Call us at +91-7440992424 or email info@doaguru.com. We offer a FREE website audit and FREE consultation for new clients. Our team will analyse your current digital presence, understand your goals, and propose a custom plan. No commitment required for the initial consultation."
                  }
                },
                {
                  "@type": "Question",
                  "name": "What results can I expect from DOAGuru's SEO services?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Results vary by industry and competition, but typical DOAGuru clients experience: 40-60% increase in organic website traffic within 6 months, top 10 Google rankings for targeted keywords, 2-3x improvement in lead generation, and improved brand visibility online. We set realistic expectations from day one and share monthly progress reports."
                  }
                },
                {
                  "@type": "Question",
                  "name": "Does DOAGuru develop mobile apps for Android and iOS?",
                  "acceptedAnswer": {
                    "@type": "Answer",
                    "text": "Yes! DOAGuru InfoSystems develops high-performance mobile apps for both Android and iOS platforms. We build everything from MVP apps for startups to full-scale enterprise applications. Our apps are designed for seamless user experience, robust backend architecture, and scalable deployment. Get in touch for a FREE app consultation."
                  }
                }
              ]
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "Organization",
              "@id": "https://doaguru.com/#organization",
              "name": "DOAGuru InfoSystems",
              "url": "https://doaguru.com/",
              "logo": "https://doaguru.com/static/media/Logo3.106799d74e5dc5b50c66.png",
              "image": "https://doaguru.com/static/media/Logo3.106799d74e5dc5b50c66.png",
              "email": "info@doaguru.com",
              "telephone": "+91-7440992424",
              "description": "DOAGuru InfoSystems is a leading Digital Marketing and IT Solutions company serving businesses across India.",
              "foundingLocation": {
                "@type": "Place",
                "name": "Jabalpur, Madhya Pradesh, India"
              },
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "1815 Wright Town",
                "addressLocality": "Jabalpur",
                "addressRegion": "Madhya Pradesh",
                "postalCode": "482002",
                "addressCountry": "IN"
              },
              "areaServed": {
                "@type": "Country",
                "name": "India"
              },
              "sameAs": [
                "https://www.facebook.com/doaguruinfosystems/",
                "https://www.linkedin.com/company/doaguru-infosystem/",
                "https://www.instagram.com/doaguru_infosystem/",
                "https://x.com/DoaguruS",
                "https://www.youtube.com/@doaguru4230"
              ],
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.9",
                "reviewCount": "70",
                "bestRating": "5"
              }
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "WebSite",
              "@id": "https://doaguru.com/#website",
              "url": "https://doaguru.com/",
              "name": "DOAGuru InfoSystems",
              "publisher": {
                "@id": "https://doaguru.com/#organization"
              }
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "LocalBusiness",
              "@id": "https://doaguru.com/#localbusiness",
              "name": "DOAGuru InfoSystems",
              "image": "https://doaguru.com/static/media/Logo3.106799d74e5dc5b50c66.png",
              "url": "https://doaguru.com/",
              "telephone": ["+91-7440992424", "+91-9201724365"],
              "email": "info@doaguru.com",
              "address": {
                "@type": "PostalAddress",
                "streetAddress": "1815 Wright Town",
                "addressLocality": "Jabalpur",
                "addressRegion": "Madhya Pradesh",
                "postalCode": "482002",
                "addressCountry": "IN"
              },
              "areaServed": {
                "@type": "Country",
                "name": "India"
              },
              "aggregateRating": {
                "@type": "AggregateRating",
                "ratingValue": "4.9",
                "reviewCount": "70",
                "bestRating": "5"
              }
            })}
          </script>
          <script type="application/ld+json">
            {JSON.stringify({
              "@context": "https://schema.org",
              "@type": "BreadcrumbList",
              "itemListElement": [
                {
                  "@type": "ListItem",
                  "position": 1,
                  "name": "Home",
                  "item": "https://doaguru.com/"
                }
              ]
            })}
          </script>


          <link rel="canonical" href={`${process.env.REACT_APP_API_URL}/`}></link>
        </Helmet>
        <div style={{ overflow: "hidden" }}>
          {/* <Finalnav /> */}
          {/* <HeaderOne/> */}
          {/* <Breadcrumb/>  */}

          {/* <Header /> */}
          {/* <HeroHome/> */}
          <HeroHomeTwo />
          {/* <HeroHomeFive/> */}
          <Header />
          {/* <VideoHomeTwo setIsVideoOpen={setIsVideoOpen}/> */}
          <AboutHomeOne />
          <ServiceHomeOne />
          <Portfolio />
          <Testimonial />
          <OurClient style_2={true} />
          <Contact style_2={true} />
          <FooterOne />
          {/* <DoaguruBannerDisplay/> */}
          {/* <Information />  */}
          {/* <HomeContent/> */}
          {/* <ContactUs/> */}
          {/* <Connect /> */}
          {/* <Homee /> */}
          {/* <Service /> */}
          {/* <Cards /> */}
          {/* <Carousel /> */}
          {/* <Testimonials /> */}
          {/* <Footer /> */}
          {/* <VideoPopup
        isVideoOpen={isVideoOpen}
        setIsVideoOpen={setIsVideoOpen}
        videoId={"gmOR6AzgyHI"}
      /> */}
        </div>
      </Wrapper>
    </>
  );
}

export default Homepage;
const Wrapper = styled.div`
  /* background-image: url();
  background-size: 100% 100%, 100% 100%;
  background-position: right top;
  background-repeat: no-repeat; */
`;

//  <meta
//           name="description"
//           content="DOAGuru InfoSystems, is the best digital marketing company in India. Our comprehensive range of services spans SEO, PPC, social media marketing, content marketing, email marketing, and more, tailored to meet the diverse needs of our clients all over India and beyond.
//         "
//         />
